import React, { useCallback } from 'react';

import * as actions from '../../containers/DesktopApplication/desktopApplicationActions';
import { APPLICATION_SETTINGS_FIELDS } from '../../common/fields';
import { CSR_TYPES } from '../../common/certTypes';
import { SERVER_TYPE, FEATURE_FLAGS_NAMES } from '@silverfort-nodelibs/common/utils/consts';

import SwitchField from '../Controls/SwitchField/SwitchField';
import SelectField from '../Controls/SelectField/SelectField';
import TextInput from '../Controls/TextInput/TextInput';
import Certificate from '../Controls/Certificate/Certificate';
import useFeature from '../../hooks/featureFlags/useFeature';
import { filterFieldsBySystemMode } from '../../common/utils';

const {
    MESSAGING_SERVICES_ENABLED,
    SAAS_MESSAGING_SERVICES_ENABLED,
    MESSAGING_SERVICES_HA_ENABLED,
    DISPLAY_COMPANY_LOGO,
    CUSTOM_MFA_INTEGRATION,
    CUSTOM_MFA_INTEGRATION_KEY,
    USER_ENROLLMENT_WINDOW,
    SECONDARY_URL,
    DEFAULT_CERTIFICATE_REQUEST,
    DEFAULT_CERTIFICATE
} = APPLICATION_SETTINGS_FIELDS;

const ApplicationSettings = ({ fields, dispatch, showAryaHAToggle }) => {
    const systemMode = useFeature(FEATURE_FLAGS_NAMES.SystemMode);
    const filteredFields = filterFieldsBySystemMode(fields, systemMode);
    const enabledField = filteredFields[MESSAGING_SERVICES_ENABLED.ID];
    const enabledSaasField = filteredFields[SAAS_MESSAGING_SERVICES_ENABLED.ID];
    const enableHAField = showAryaHAToggle && filteredFields[MESSAGING_SERVICES_HA_ENABLED.ID];
    const showCompanyLogoField = filteredFields[DISPLAY_COMPANY_LOGO.ID];
    const customMfaIntegration = filteredFields[CUSTOM_MFA_INTEGRATION.ID];
    const customMfaIntegrationKey = filteredFields[CUSTOM_MFA_INTEGRATION_KEY.ID];
    const userEnrollmentWindow = filteredFields[USER_ENROLLMENT_WINDOW.ID];
    const secondaryUrl = filteredFields[SECONDARY_URL.ID];
    const certificateRequest = filteredFields[DEFAULT_CERTIFICATE_REQUEST.ID];
    const certificate = filteredFields[DEFAULT_CERTIFICATE.ID];

    const dispatchUpdate = useCallback(
        (fieldId, value) => {
            dispatch({
                type: actions.UPDATE_APPLICATION_SETTINGS,
                payload: { fieldId, value }
            });
        },
        [dispatch]
    );

    return (
        <>
            {enabledField && <SwitchField field={enabledField} changed={dispatchUpdate} />}
            {enabledSaasField && <SwitchField field={enabledSaasField} changed={dispatchUpdate} />}
            {enableHAField && <SwitchField field={enableHAField} changed={dispatchUpdate} />}
            {showCompanyLogoField && <SwitchField field={showCompanyLogoField} changed={dispatchUpdate} />}
            {customMfaIntegration && <SwitchField field={customMfaIntegration} changed={dispatchUpdate} />}
            {customMfaIntegrationKey && (
                <TextInput type="password" field={customMfaIntegrationKey} changed={dispatchUpdate} />
            )}
            {userEnrollmentWindow && (
                <SelectField
                    field={userEnrollmentWindow}
                    changed={dispatchUpdate}
                    options={[
                        { value: true, label: 'Left click' },
                        { value: false, label: 'Left click + Ctrl' }
                    ]}
                />
            )}
            {secondaryUrl && (
                <TextInput
                    field={secondaryUrl}
                    placeholder="https://secondary.silverfort-push-services:8443"
                    changed={dispatchUpdate}
                />
            )}
            {certificateRequest && certificate && (
                <Certificate
                    header={certificate.name}
                    desc="Upload a default certificate to set up trusted communication between the Desktop App and the Desktop Messaging Services"
                    certificate={certificate}
                    certificateRequest={certificateRequest}
                    certType={CSR_TYPES.PUSH_SERVICES}
                    serverType={SERVER_TYPE.ARYA}
                    changed={dispatchUpdate}
                />
            )}
        </>
    );
};

export default ApplicationSettings;
